angular.module('bizmetryApp').controller('RoleExplorerPickerController', [
    '$scope', '$mdDialog', '$timeout', '$sce', 'RolesService',
    'selectedRoles', 'accountId',
    function ($scope, $mdDialog, $timeout, $sce, RolesService,
        selectedRoles, accountId) {

        $scope.rolesHierarchy   = [];
        $scope.displayHierarchy = [];
        $scope.expandedNodes    = {};
        $scope.search           = { query: '' };
        $scope.searchMatchCount = -1;
        $scope.searchFocused    = false;
        $scope.loading          = true;

        var _selectedMap = {};
        (selectedRoles || []).forEach(function (item) {
            if (item && item.id) _selectedMap[item.id] = item;
        });

        var _searchDebounce = null;

        // ── Cargar jerarquía desde API ────────────────────────────────────
        RolesService.getRolesHierarchy(accountId)
            .then(function (response) {
                var data = response.data;
                var raw  = data.roles || data || [];

                $scope.rolesHierarchy   = _sortByPermissions(raw);
                $scope.displayHierarchy = $scope.rolesHierarchy;

                _expandInitialSelection($scope.rolesHierarchy);
                _autoExpandFirstLevel();
            })
            .catch(function (err) {
                console.error('❌ Error loading roles hierarchy:', err);
                $scope.rolesHierarchy   = [];
                $scope.displayHierarchy = [];
            })
            .finally(function () {
                $scope.loading = false;
            });

        function _autoExpandFirstLevel() {
            ($scope.rolesHierarchy || []).forEach(function (r) {
                $scope.expandedNodes[r.id] = true;
            });
        }

        function _expandInitialSelection(roles) {
            (roles || []).forEach(function (role) {
                if (_selectedMap[role.id]) {
                    _selectWithChildren(role);
                } else {
                    _expandInitialSelection(role.childRoles);
                }
            });
        }

        // ── Ordenamiento por número de permisos (decreciente) ─────────────
        function _sortByPermissions(roles) {
            if (!roles || !roles.length) return [];
            return roles
                .slice()
                .sort(function (a, b) {
                    return _countPerms(b) - _countPerms(a);
                })
                .map(function (r) {
                    var clone = angular.copy(r);
                    if (clone.childRoles && clone.childRoles.length) {
                        clone.childRoles = _sortByPermissions(clone.childRoles);
                    }
                    return clone;
                });
        }

        // ── Statistics ────────────────────────────────────────────────────
        $scope.getTotalRolesCount = function () {
            return ($scope.rolesHierarchy || []).length;
        };

        $scope.getTotalPermissionsCount = function () {
            var unique = {};
            ($scope.rolesHierarchy || []).forEach(function (role) {
                (role.permissions || []).forEach(function (p) { unique[p.id] = true; });
            });
            return Object.keys(unique).length;
        };

        $scope.getPermissionsCountForRole = function (role) { return _countPerms(role);      };
        $scope.getChildRolesCountForRole  = function (role) { return _countChildRoles(role); };

        function _countPerms(role) {
            if (!role) return 0;
            var n = (role.permissions || []).length;
            (role.childRoles || []).forEach(function (c) { n += _countPerms(c); });
            return n;
        }

        function _countChildRoles(role) {
            if (!role || !(role.childRoles || []).length) return 0;
            var n = role.childRoles.length;
            role.childRoles.forEach(function (c) { n += _countChildRoles(c); });
            return n;
        }

        // ── Expand / collapse ─────────────────────────────────────────────
        $scope.toggleNode     = function (id) { $scope.expandedNodes[id] = !$scope.expandedNodes[id]; };
        $scope.isNodeExpanded = function (id) { return !!$scope.expandedNodes[id]; };
        $scope.expandAll      = function ()   { _expandAll($scope.displayHierarchy); };
        $scope.collapseAll    = function ()   { $scope.expandedNodes = {}; };

        function _expandAll(roles) {
            (roles || []).forEach(function (r) {
                $scope.expandedNodes[r.id] = true;
                _expandAll(r.childRoles);
            });
        }

        // ── Selection con cascada ─────────────────────────────────────────
        $scope.isSelected       = function (item) { return !!(item && item.id && _selectedMap[item.id]); };
        $scope.getSelectedCount = function ()      { return Object.keys(_selectedMap).length; };

        $scope.toggleSelection = function (item, $event) {
            if ($event) $event.stopPropagation();
            if (!item || !item.id) return;

            if (_selectedMap[item.id]) {
                _deselectWithChildren(item);
                _deselectParentsOf(item.id, $scope.rolesHierarchy);
            } else {
                _selectWithChildren(item);
                _syncParentsOf(item.id, $scope.rolesHierarchy);
            }
        };

        function _resolveType(item) {
            var hasChildren = (item.childRoles  && item.childRoles.length  > 0) ||
                              (item.permissions && item.permissions.length > 0);
            return hasChildren ? 'ROLE' : 'PERMISSION';
        }

        function _selectWithChildren(item) {
            if (!item || !item.id) return;
            _selectedMap[item.id] = angular.extend({}, item, { type: _resolveType(item) });
            (item.childRoles  || []).forEach(function (c) { _selectWithChildren(c); });
            (item.permissions || []).forEach(function (p) { _selectWithChildren(p); });
        }

        function _deselectWithChildren(item) {
            if (!item || !item.id) return;
            delete _selectedMap[item.id];
            (item.childRoles  || []).forEach(function (c) { _deselectWithChildren(c); });
            (item.permissions || []).forEach(function (p) { delete _selectedMap[p.id]; });
        }

        function _syncParentsOf(itemId, roles) {
            (roles || []).forEach(function (role) {
                var isDirect = _isDirectChild(itemId, role);
                var isDeep   = !isDirect && _containsDescendant(itemId, role);
                if (isDirect || isDeep) {
                    if (isDirect) {
                        if (_allChildrenSelected(role)) {
                            _selectedMap[role.id] = angular.extend({}, role, { type: _resolveType(role) });
                        } else {
                            delete _selectedMap[role.id];
                        }
                    }
                    _syncParentsOf(itemId, role.childRoles);
                }
            });
        }

        function _deselectParentsOf(itemId, roles) {
            (roles || []).forEach(function (role) {
                if (_isDirectChild(itemId, role) || _containsDescendant(itemId, role)) {
                    delete _selectedMap[role.id];
                    _deselectParentsOf(itemId, role.childRoles);
                }
            });
        }

        function _isDirectChild(itemId, role) {
            return (role.childRoles  || []).some(function (c) { return c.id === itemId; }) ||
                   (role.permissions || []).some(function (p) { return p.id === itemId; });
        }

        function _containsDescendant(itemId, role) {
            if (_isDirectChild(itemId, role)) return true;
            return (role.childRoles || []).some(function (c) {
                return _containsDescendant(itemId, c);
            });
        }

        function _allChildrenSelected(role) {
            var children    = role.childRoles  || [];
            var permissions = role.permissions || [];
            if (children.length === 0 && permissions.length === 0) return false;
            return children.every(function (c)   { return !!_selectedMap[c.id]; }) &&
                   permissions.every(function (p) { return !!_selectedMap[p.id]; });
        }

        function _getSelectedArray() {
            return Object.keys(_selectedMap)
                .map(function (k) { return _selectedMap[k]; })
                .filter(function (item) {
                    return !_hasSelectedAncestor(item.id, $scope.rolesHierarchy);
                });
        }

        function _hasSelectedAncestor(itemId, roles) {
            return (roles || []).some(function (role) {
                if (_isDirectChild(itemId, role) || _containsDescendant(itemId, role)) {
                    if (_selectedMap[role.id]) return true;
                    return _hasSelectedAncestor(itemId, role.childRoles);
                }
                return false;
            });
        }

        // ── Search ────────────────────────────────────────────────────────
        $scope.onSearchChange = function () {
            if (_searchDebounce) $timeout.cancel(_searchDebounce);
            _searchDebounce = $timeout(function () {
                _applySearch($scope.search.query);
            }, 220);
        };

        $scope.clearSearch = function () {
            $scope.search.query     = '';
            $scope.searchMatchCount = -1;
            $scope.displayHierarchy = $scope.rolesHierarchy;  // ya ordenado
        };

        function _applySearch(query) {
            var q = (query || '').trim().toLowerCase();
            if (!q) {
                $scope.searchMatchCount = -1;
                $scope.displayHierarchy = $scope.rolesHierarchy;
                return;
            }
            var totalMatches = 0;
            $scope.displayHierarchy = _pruneTree($scope.rolesHierarchy, q, function (n) {
                totalMatches += n;
            });
            $scope.searchMatchCount = totalMatches;
            _expandAll($scope.displayHierarchy);
            $timeout(function () {
                var el = document.querySelector('.rep-role-header--match, .rep-perm-node--match');
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 100);
        }

        function _pruneTree(roles, q, addCount) {
            var result = [];
            (roles || []).forEach(function (role) {
                var pruned = _pruneRole(role, q, addCount);
                if (pruned) result.push(pruned);
            });
            return result;
        }

        function _pruneRole(role, q, addCount) {
            var selfMatch      = _matches(role.name, q) || _matches(role.description, q);
            var processedPerms = (role.permissions || []).map(function (p) {
                var m = _matches(p.name, q) || _matches(p.description, q) || _matches(p.id, q);
                return angular.extend({}, p, { _isMatch: m });
            });
            var matchingPerms  = processedPerms.filter(function (p) { return p._isMatch; });
            var prunedChildren = [];
            var prunedById     = {};
            (role.childRoles || []).forEach(function (c) {
                var pr = _pruneRole(c, q, addCount);
                if (pr) { prunedChildren.push(pr); prunedById[pr.id] = pr; }
            });
            var hasDescendantMatch = matchingPerms.length > 0 || prunedChildren.length > 0;
            if (!selfMatch && !hasDescendantMatch) return null;
            if (selfMatch) addCount(1);
            addCount(matchingPerms.length);
            if (selfMatch) {
                var allChildren = (role.childRoles || []).map(function (c) {
                    return prunedById[c.id] || angular.extend({}, c, { _isMatch: false });
                });
                return angular.extend({}, role, {
                    _isMatch:    true,
                    permissions: processedPerms,
                    childRoles:  allChildren
                });
            }
            return angular.extend({}, role, {
                _isMatch:    false,
                permissions: matchingPerms,
                childRoles:  prunedChildren
            });
        }

        function _matches(text, q) {
            return !!text && text.toLowerCase().indexOf(q) !== -1;
        }

        // ── Highlight ─────────────────────────────────────────────────────
        $scope.highlight = function (text) {
            if (!text) return $sce.trustAsHtml('');
            var escaped = _esc(String(text));
            var q = ($scope.search.query || '').trim();
            if (!q) return $sce.trustAsHtml(escaped);
            var re = new RegExp('(' + _escRe(_esc(q)) + ')', 'gi');
            return $sce.trustAsHtml(
                escaped.replace(re, '<span class="search-highlight">$1</span>')
            );
        };

        function _esc(s) {
            return s
                .replace(/&/g,  '&amp;')
                .replace(/</g,  '&lt;')
                .replace(/>/g,  '&gt;')
                .replace(/"/g,  '&quot;');
        }

        function _escRe(s) {
            return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }

        // ── Dialog actions ────────────────────────────────────────────────
        $scope.confirm = function () {
            $mdDialog.hide({ selectedRoles: _getSelectedArray() });
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.selectAll = function () {
            ($scope.rolesHierarchy || []).forEach(function (role) {
                _selectWithChildren(role);
            });
        };

        $scope.clearAll = function () {
            _selectedMap = {};
        };
    }
]);